/**
 * `BrandFooterLine` — small quiet copyright/ABN line for marketing pages
 * (Landing, Privacy, Terms) and Settings. Single source of truth for the
 * exact text so a future update flows to every surface at once.
 *
 * Explicitly NOT used on Capture, Jobs, Ledger, Tax AI, Personal Tax or any
 * primary work screen — those should stay uncluttered. PDF/pack/invoice
 * headers continue to use the tradie's `business_name` + `abn` from their
 * Settings profile; this line is separate BuildIntel corporate footprint.
 */
export default function BrandFooterLine({ className = "", testId = "brand-footer-line" }) {
  return (
    <div
      data-testid={testId}
      className={`text-[11px] leading-relaxed text-white/40 ${className}`}
    >
      © 2026 BuildIntel AI. All rights reserved.
      <br />
      ABN 82 319 960 400
    </div>
  );
}
